// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"076bc659","869":"14485a1f"}[chunkId] + ".chunk.js";
};